export default "__VITE_ASSET__23b63a08__"